import { uniqueId } from 'lodash';
import * as types from '../constants/action-types';
import { SERVER_ERROR_ACTION_NAME, TOAST_DEFAULT_HIDE_DELAY, TOAST_ID_KEY, ToastType, } from '../constants';
import localeService from '../helpers/locale-service';
import { getError } from '../helpers/get-error';
const tIdCategory = 'notification';
const tGeneralSubCategory = 'general';
const timers = {};
export const addToastByActionName = (type, actionName, msg, timeout) => (dispatch) => {
    const message = msg ||
        localeService.formatMessageById(`${tIdCategory}.${actionName || tGeneralSubCategory}.${type}`);
    return dispatch(addToast(type, message, timeout));
};
export const addToastByTranslationId = (type, translationId, timeout) => (dispatch) => {
    const message = localeService.formatMessageById(`${tIdCategory}.${translationId}`);
    return dispatch(addToast(type, message, timeout));
};
export const addToastServerError = (error, timeout) => (dispatch) => {
    const err = getError(error);
    return (err &&
        dispatch(addToastByActionName(ToastType.error, SERVER_ERROR_ACTION_NAME, err.message, timeout)));
};
export const addToast = (type, msg, timeout) => (dispatch) => {
    const message = msg ||
        localeService.formatMessageById(`${tIdCategory}.${tGeneralSubCategory}.${type}`);
    const id = uniqueId(TOAST_ID_KEY);
    timers[id] = setTimeout(() => dispatch(removeToast(id)), timeout || TOAST_DEFAULT_HIDE_DELAY[type]);
    dispatch({ type: types.ADD_TOAST, payload: { id, type, message } });
    return id;
};
export const removeToast = (id) => (dispatch) => {
    clearTimeout(timers[id]);
    delete timers[id];
    dispatch({ type: types.REMOVE_TOAST, payload: id });
};
